import { render, staticRenderFns } from "./rankinglist.vue?vue&type=template&id=2382af5b&scoped=true&"
import script from "./rankinglist.vue?vue&type=script&lang=js&"
export * from "./rankinglist.vue?vue&type=script&lang=js&"
import style0 from "./rankinglist.vue?vue&type=style&index=0&id=2382af5b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2382af5b",
  null
  
)

export default component.exports